import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
// import LegacyInterceptor from '@finx/web-repository/src/apis/Legacy/LegacyInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { Pendencia, PendenciaMensagem, TipoDocumentoUpload } from '@/types/_'
import { getUserDefaultBackofficeArea } from '@/utils/common'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()
// const api = new LegacyInterceptor()

export default {

  async abrirMensagem(solicitacaoId: string, pendenciaMensagem: PendenciaMensagem[]) {
    const url = window.location.href.toString().split('/')
    let area = ''
    switch (url[url.length - 1]) {
      case 'pre-anestesico':
        area = 'PreAnestesia'
        break
      case 'agencia-transfusional':
        area = 'AgenciaTransfusional'
        break
      default:
        area = url[url.length - 1].trim().length === 0 ? getUserDefaultBackofficeArea() : url[url.length - 1]
    }

    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/${area}/abrir`, pendenciaMensagem)
    return factory.build(request)
  },


  async enviarMensagemPendencia(solicitacaoId: string, pendencia: Pendencia) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/mensagens`, pendencia)
    return factory.build(request)
  },


  async getMensagemAberta(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/pendencias/aberta`)
    return factory.build(request)
  },

  async encerrarPendencia(solicitacaoId: string) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/encerrar`, {})
    return factory.build(request)
  },

  async medicoResponde(solicitacaoId: string) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/pendencias/medico-responde`, {})
    return factory.build(request)
  },

  async abrirPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string[] }) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/agendamento/agendamentoAbrePendenciaAdministrativa`, data)
    return factory.build(request)
  },

  async resolverPendenciaAdministrativa(solicitacaoId: string, data: { comentarios: string[] }) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/agendamento/agendamentoResolvePendenciaAdministrativa`, data)
    return factory.build(request)
  },

  async uploadDocumento(formData: any, hospitalId: string, tipoDocumento: string) {
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const request = await api.upload(`hospitais/${hospitalId}/documentos/upload/${tipoDocumento}`, formData, header)
    return factory.build(request)
  },
}
